
import {
    GET_BUS_OPERATORS_URL,
    GET_BOOKING_PARTNERS_URL,
    UPDATE_ALLOWED_BOOKING_OPERATORS_URL
} from "./../utils/api-url";
import { postCall } from "../utils/network.util";


export const getActiveOperators=(onSuccess=()=>{},onFailure=()=>{})=>{
  var fetched = postCall(GET_BUS_OPERATORS_URL, {});
  fetched.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload.travelsInfo);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to get operators");
    })
}

export const getBookingPartners=(operatorCode,onSuccess=()=>{},onFailure=()=>{})=>{
  var fetched = postCall(GET_BOOKING_PARTNERS_URL, {operatorCode:operatorCode});
  fetched.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to get booking partners");
    })
}

export const updateAllowedBookingOperators=(operatorCode,allowedOperatorCodes,onSuccess=()=>{},onFailure=()=>{})=>{
  var updated = postCall(UPDATE_ALLOWED_BOOKING_OPERATORS_URL, {
    operatorCode:operatorCode,
    allowedOperatorCodes:allowedOperatorCodes
  });
  updated.then((data) => {
      if(data.status === "SUCCESS" && data.payload.Status === "SUCCESS"){
          onSuccess(data.payload.Payload);
      }else{
        onFailure(data.payload.Message);
      }
    })
    .catch((reason)=> {
      onFailure("Failed to update booking partners");
    })
}
